<cc-box>
  <div class="lg-container" box header>{{'LEAD_GENERATION.CREATOR.POPUP.THEME_COLOR' | translate}}</div>
  <div box content>
    <cc-lg-color-bubble-set [control]="popupSettings.controls.theme"></cc-lg-color-bubble-set>
  </div>

  <div box content class="top-border">
    <cc-lg-color-input label="{{'LEAD_GENERATION.CREATOR.POPUP.HEX_COLOR_CODE' | translate }}"
                       [control]="popupSettings.controls.customColor"></cc-lg-color-input>
    <div class="box-part">
      <cc-lg-color-input label="{{'LEAD_GENERATION.CREATOR.POPUP.FONT_HEX_COLOR_CODE' | translate }}"
                         [control]="popupSettings.controls.customFontColor"></cc-lg-color-input>
    </div>
  </div>
</cc-box>
